export default __webpack_public_path__ + "static/media/SteelsTableImg3.89b20b2f.jpg";